import React from 'react'

import clsx from 'clsx'
import { useTheme } from '@mui/material/styles'

import FONTS from '@/src/fonts'

type Props = {
  title: string
  actions?: any
  classNameAction?: string
}

const FieldsetHeader: React.FC<Props> = ({ title, actions = null, classNameAction = '' }) => {
  const theme = useTheme()

  const containerClassName = 'flex justify-between items-center relative mt-2 mb-4'
  const headerActionsClassName = 'mr-5'
  const titleStyle: React.CSSProperties = {
    fontSize: theme.typography.pxToRem(21),
    fontWeight: FONTS.WEIGHT.BOLD,
    textTransform: 'uppercase',
    marginLeft: '1.25rem',
    marginRight: '1.25rem',
    position: 'relative',
    top: 7,
    left: -12,
    height: 12,
    paddingRight: 8,
    background: `${theme.palette.primary.main}33`,
  }
  const titleInnerStyle: React.CSSProperties = {
    position: 'relative',
    top: -14,
    left: 12,
  }

  return (
    <div className={containerClassName}>
      {title ? (
        <div style={titleStyle}>
          <div style={titleInnerStyle}>{title}</div>
        </div>
      ) : (
        <div style={titleStyle} />
      )}
      <div className={clsx([headerActionsClassName, classNameAction])}>{actions}</div>
    </div>
  )
}

export default FieldsetHeader
